<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<div class="w-full min-h-screen bg-background flex md:items-center md:justify-center p-4 md:p-[5%]">
  <!-- Card -->
  <div
    class="w-full max-w-[900px] overflow-hidden bg-white rounded-3xl shadow-md flex flex-col md:flex-row min-h-[calc(100vh-2rem)] md:min-h-0"
  >
    <!-- LEFT SIDE -->
    <div
      class="hidden md:flex md:w-1/2 relative items-center justify-center"
      style="background-color: #106eb8"
    >
      <img
        class="absolute inset-0 w-full h-full object-cover opacity-20"
        [src]="
          featureImageUrl()
            ? featureImageUrl()
            : 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?q=80&w=2187'
        "
        alt=""
      />
    </div>

    <!-- RIGHT SIDE -->
    <div class="flex md:w-1/2 flex-col px-6 py-8 md:py-[65px] flex-1">
      <div class="w-full max-w-md mx-auto flex flex-col flex-1">
        <!-- ============================= -->
        <!-- MENSAJE ENVIADO -->
        <!-- ============================= -->
        <ng-container *ngIf="messageSent(); else forgotForm">
          <div class="flex flex-col flex-1 text-center">
            <!-- TEXTO ARRIBA -->
            <div>
              <p class="text-[24px] mb-4 font-bold">
                {{ 'SHARED.SIGNIN_FORGOT-PASSWORD.MESSAGE_SENT_TITLE' | translate }}
              </p>

              <p class="text-[14px]">
                {{ 'SHARED.SIGNIN_FORGOT-PASSWORD.MESSAGE_SENT_DETAIL' | translate }}
              </p>
            </div>

            <!-- BOTÓN ABAJO -->
            <div class="mt-auto pt-8">
              <lib-custom-button
                [label]="'Ir al inicio de sesión'"
                variant="primary"
                class="w-full cursor-pointer"
                [fullWidth]="true"
                (click)="goToLogin()"
              ></lib-custom-button>
            </div>
          </div>
        </ng-container>

        <!-- ============================= -->
        <!-- FORMULARIO -->
        <!-- ============================= -->
        <ng-template #forgotForm>
          <form
            [formGroup]="forgotPasswordForm"
            (ngSubmit)="onSubmit()"
            class="flex flex-col flex-1"
          >
            <!-- CONTENIDO CENTRADO -->
            <div class="flex flex-col flex-1">
              <p class="text-[24px] mb-4 text-center font-bold">
                {{ 'SHARED.SIGNIN_FORGOT-PASSWORD.RECOVER_ACCOUNT' | translate }}
              </p>

              <p class="text-[14px] mb-6 text-center">
                {{ 'SHARED.SIGNIN_FORGOT-PASSWORD.INSTRUCTIONS' | translate }}
              </p>

              <lib-custom-input
                [label]="'SHARED.SIGNIN_FORGOT-PASSWORD.EMAIL_LABEL' | translate"
                type="email"
                [placeholder]="'SHARED.SIGNIN_FORGOT-PASSWORD.EMAIL_PLACEHOLDER' | translate"
                name="email"
                formControlName="email"
                iconLeft="fa fa-envelope"
              >
              </lib-custom-input>
            </div>

            <!-- BOTONES ABAJO -->
            <div class="pt-8">
              <div class="flex flex-col md:flex-row gap-3 md:items-center">
                <!-- BOTÓN PRINCIPAL -->
                <div class="w-full md:w-1/2 order-1 md:order-2">
                  <lib-custom-button
                    class="w-full"
                    [label]="'SHARED.SIGNIN_FORGOT-PASSWORD.BUTTON' | translate"
                    type="submit"
                    variant="primary"
                    [loading]="loading()"
                    [disabled]="forgotPasswordForm.invalid || loading()"
                    [fullWidth]="true"
                  ></lib-custom-button>
                </div>

                <!-- REGRESAR -->
                <div
                  class="w-full md:w-1/2 flex items-center justify-center md:justify-start order-2 md:order-1"
                >
                  <a
                    [routerLink]="signInLink()"
                    class="font-medium text-[14px] text-blue-600 hover:text-blue-500 text-center md:text-left w-full"
                  >
                    {{ 'SHARED.SIGNIN_FORGOT-PASSWORD.BACK_TO_LOGIN_LINK' | translate }}
                  </a>
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>
